export enum FieldType {
  FullName,
  StreetAddress,
  UnitNumber,
  City,
  CountryRegion,
  State,
  PostalCode,
  Phone,
  CustomerIdNumber,
}
